import React from 'react'
import { MdDeleteForever } from 'react-icons/md'
import mastercard from '../../assets/images/mastercard.png'
import visa from '../../assets/images/visa.png'
import { cardImageSelector } from '../../config/utils/CardImageSelector'

const PaymentCard = ({ card, isDeleteCard, cardDeleteHandler }) => {

    const deleteHandler = (id) => {
        isDeleteCard && cardDeleteHandler(id)
    }

    return (
        <div className='flex gap-5 items-center bg-[#F4F4FA] p-4 w-fit' key={card?.id}>
            <img className='w-auto' src={cardImageSelector(card?.brand)} />
            <div className='flex flex-col items-start gap-1'>
                <p className='font-semibold'>{card?.brand == 'visa' ? 'Debit card' : 'Master Card'}</p>
                <span>**** **** **** {card?.last4}</span>
            </div>
            {
                isDeleteCard ?
                    <div className='p-1 bg-[#BF0034] self-start mt-[-5px] mr-[-3px] cursor-pointer' onClick={() => deleteHandler(card?.id)}>
                        <MdDeleteForever color='white' size={20} />
                    </div>
                    : ''
            }
        </div>
    )
}

export default PaymentCard